<script setup lang="ts">
import { ref, computed } from 'vue';
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';
import { FilterMatchMode, FilterOperator } from '@primevue/core/api';
import DataTable from 'primevue/datatable';
import ToggleSwitch from 'primevue/toggleswitch';
import TableColumn from 'primevue/column';

interface Props {
  groupTravelRole: object[];
  loading: boolean;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:groupTravelRole': [value: any] }>();

const userAuthorizationsStore = useUserAuthorizationsStore();
const authorizations: any = userAuthorizationsStore.permissionByRole;
const filters = ref();

const group_travel_role = computed({
  get() {
    return props.groupTravelRole;
  },
  set(value) {
    emits('update:groupTravelRole', value);
  }
});

const initFilters = () => {
  filters.value = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    permissions: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }
  };
};
initFilters();
</script>
<template>
  <div class="card">
    <DataTable v-model:filters="filters" :value="group_travel_role" paginator showGridlines :rows="170" filterDisplay="menu" :globalFilterFields="['permissions']">
      <TableColumn field="permissions" :header="$t('role.permission')" frozen>
        <template #body="{ data }">
          <span v-tooltip="data.code">
            {{ $t(`permisson.${data.rowname}`) }}
          </span>
        </template>
      </TableColumn>
      <TableColumn field="name" :header="$t('role.admin')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.admin" />
        </template>
      </TableColumn>
      <TableColumn field="logo" :header="$t('role.groups_coordinator')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.co" />
        </template>
      </TableColumn>
      <TableColumn field="sts" :header="$t('role.revenua_management')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.rm" />
        </template>
      </TableColumn>
      <TableColumn :header="$t('role.groups_commercial')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.gc" />
        </template>
      </TableColumn>
      <TableColumn :header="$t('role.group_air')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.ao" />
        </template>
      </TableColumn>
      <TableColumn :header="$t('role.group_cruise')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.cr" />
        </template>
      </TableColumn>
      <TableColumn :header="$t('role.group_incentives')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.in" />
        </template>
      </TableColumn>
      <TableColumn :header="$t('role.supervisor')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.su" />
        </template>
      </TableColumn>
      <TableColumn :header="$t('role.sales_team')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.asm" />
        </template>
      </TableColumn>
      <TableColumn :header="$t('role.travel_agent')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.tagent" />
        </template>
      </TableColumn>
      <TableColumn :header="$t('role.marketing_management')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.marketing" />
        </template>
      </TableColumn>
      <TableColumn :header="$t('role.accounting')">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.accounting" />
        </template>
      </TableColumn>
      <TableColumn :header="$t(`role.it_support`)">
        <template #body="{ data }">
          <ToggleSwitch :disabled="!authorizations?.configurationPage?.role_update_edit" v-model="data.support" />
        </template>
      </TableColumn>
    </DataTable>
  </div>
</template>
